module.exports = __webpack_public_path__ + "img/expostyle_0031_kiwi_pantone186320tpg.392aa784.jpg";